import React, { createContext, useEffect, useState } from 'react';
import MainContentLayout from '../../../components/Layout/MainContentLayout';
import PageHeaderLayout from '../../../components/Layout/PageHeaderLayout';
import { useParams,useNavigate } from 'react-router-dom';
import { Button, Step, Stepper, StepLabel, Paper,} from '@mui/material';
import { ArrowBack, Close } from '@mui/icons-material';
import InitiateBooking from './InitiateBooking';
import BookingResponse from './BookingResponse';
import { CustomerService } from '../../Customer/Service';
import BookingSchedule from './BookingSchedule';
import BookingReview from './BookingReview';
import Payment from './Payment';
import { useDispatch } from 'react-redux';

const BookingDataContext = createContext();
const StepperDataContext = createContext();
const DataContext = createContext();

const AddBooking = () => {
    const menuDispatch = useDispatch();
    useEffect(() => {
        menuDispatch({
            type: 'menuSelect',
            payload: 'create-booking'
        });
    }, []);
    const navigate = useNavigate();
    const initialData ={
        bookingId:0,
        customer:'',
        selected_address:'',
        categoryId: '',      
        subCategoryId:'',            
        serviceExpert: '',
    }
    const [supportInstructions, setSupportInstructions] = useState('');
    const [cartItems,setCartItems] = useState([]);
    const [selectedCart,setSelectedCart] = useState(null);
    const [bookingInitiationData,setBookingInitiationData] = useState(initialData);
    const [dateTimeSlot,setDateTimeSlot] = useState({
        serviceDate:'',
        timeSlot:'',
    })
    const [bookingInProgressData,setBookingInProgressData] = useState(null);
    const [expertDetails,setExpertDetails] = useState({});
    const [chargeDetails, setChargeDetails] = useState({
        additionalCharge:'0',
        vistingCharge:'0',
        cancellationChargeInPercent:'0',
        timeLimitForCancellation:'0',
        isRefundable:false,
        refundableAmount:'0',
        refundableDuration:'0',
        waiveVisitCharge:'0',
    });
    const [paymentDetails,setPaymentDetails] = useState({
        paymentMode:'',
    })

    const [activeStep, setActiveStep] = useState(0);
    const [completed, setCompleted] = useState({});
    const steps = ['Initiate Booking', 'Schedule', 'Review', 'Payment'];

    const totalSteps = () => {
        return steps.length;
    };

    const completedSteps = () => {
        return Object.keys(completed).length;
    };

    const isLastStep = () => {
        return activeStep === totalSteps() - 1;
    };

    const allStepsCompleted = () => {
        return completedSteps() === totalSteps();
    };

    const handleNext = () => {
        // const newActiveStep =
        // isLastStep() && !allStepsCompleted()
        //     ? // It's the last step, but not all steps have been completed,
        //     // find the first step that has been completed
        //     steps.findIndex((step, i) => !(i in completed))
        //     : activeStep + 1;
        // setActiveStep(newActiveStep);
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };
    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }
    const handleStep = (step) => () => {
        setActiveStep(step);
    };

    const handleComplete = () => {
        // setCompleted({
        // ...completed,
        // [activeStep]: true,
        // });
        handleNext();
    };
    const setStepInComplete = () => {
        setCompleted({
        ...completed,
        [activeStep]: false,
        });
        // handleNext();
    };
    const handleReset = () => {
        setSupportInstructions('');
        setCartItems([]);
        setSelectedCart(null);
        setBookingInProgressData(null);
        setBookingInitiationData(initialData);
        setDateTimeSlot({
            serviceDate:'',
            timeSlot:'',
        });
        setExpertDetails({});
        setChargeDetails({
            additionalCharge:'0',
            vistingCharge:'0',
            cancellationChargeInPercent:'0',
            timeLimitForCancellation:'0',
            isRefundable:false,
            refundableAmount:'0',
            refundableDuration:'0',
            waiveVisitCharge:'0',
        });
        setActiveStep(0);
        setCompleted({});
        setBookingResponseDetails({});
    }

     // Data fetching state
     const [bookingResponseDetails, setBookingResponseDetails] = useState({});
    //  const [previousServices, setPreviousServices] = useState([]);
     const [isLoadingCustomerList, setIsLoadingCustomerList] = useState(false);
     const [customerList, setCustomerList] = useState([]);
     const [addressList, setAddressList] = useState([]);
     const [categoryList, setCategoryList] = useState([]);
     const [subCategoryList, setSubCategoryList] = useState([]);
     const [expertList, setExpertList] = useState([]);
     const [serviceList, setServiceList] = useState([]); 

    // fetch customer list
    const fetchCustomerlist = async()=>{
        setIsLoadingCustomerList(true)
        try {
            const customerListResponse = await CustomerService.unsortedCustomerList();
            if(customerListResponse.success===1){
            setCustomerList(customerListResponse.data)
            }
        } catch (error) {
            
        }finally{
            setIsLoadingCustomerList(false);
        }
    }
    useEffect(()=>{  
        fetchCustomerlist();
    },[])


    // Context values
    const bookingDataContextValue = {
        supportInstructions,
        setSupportInstructions,
        initialData,
        bookingInitiationData,
        setBookingInitiationData,
        dateTimeSlot,
        setDateTimeSlot,
        expertDetails,
        setExpertDetails,
        chargeDetails,
        setChargeDetails,
        paymentDetails,
        setPaymentDetails,
        cartItems,
        setCartItems,
        selectedCart,
        setSelectedCart,
        bookingInProgressData,
        setBookingInProgressData,
    };

    const stepperContextValue = {
        activeStep,
        setActiveStep,
        completed,
        setCompleted,
        handleNext,
        handleBack,
        handleStep,
        handleComplete,
        setStepInComplete,
        handleReset,
        bookingResponseDetails,
        setBookingResponseDetails,
    };

    const dataContextValue = {
        isLoadingCustomerList,
        customerList,
        addressList,
        setAddressList,
        categoryList,
        setCategoryList,
        subCategoryList,
        setSubCategoryList,
        expertList,
        setExpertList,
        serviceList,
        setServiceList,
    };

    // Determine current step component
    const renderStepContent = () => {
        switch (activeStep) {
            case 0:
                return <InitiateBooking />;
            case 1:
                return <BookingSchedule />;
            case 2:
                return <BookingReview />;
            case 3:
                return <Payment />;
            default:
                return null;
        }
    };
    
  return (
    <BookingDataContext.Provider value={bookingDataContextValue}>
        <>
            <PageHeaderLayout headerTitle={`Create New Booking`}>
                {/* <Button size='small' variant='contained' onClick={() => navigate(-1)} endIcon={<ArrowBack sx={{fontSize:'.85rem!important'}}/>} sx={{height:'fit-content',fontSize:'x-small',p:'.5% 1.25%'}}>
                    Back
                </Button> */}
            </PageHeaderLayout>
            <StepperDataContext.Provider value={stepperContextValue}>
                <Paper sx={{ overflow: "auto",padding:{xs:'2%',md:'1% 0% 1% 0%'},mb:'.25%' }}>
                    <Stepper activeStep={activeStep} alternativeLabel>
                        {steps.map((label, index) => {
                            // Find the highest completed step index
                            // const lastCompletedStep = Math.max(-1, ...Object.keys(completed).map(Number));
                            // Step is clickable if it's completed or if it's the next step after the last completed one
                            // const isClickable = completed[index] || index === lastCompletedStep + 1;
                            
                            return (
                                <Step key={label} completed={completed[index]}>
                                    <StepLabel 
                                        sx={{
                                            '& .MuiStepLabel-label': {
                                                fontSize: '0.75rem', // Controls the label text size
                                                fontWeight: 600,
                                            },
                                            '& .MuiStepIcon-root': {
                                                fontSize: '1.2rem', // Controls the size of the circle
                                            },
                                        }}
                                    >
                                        {label}
                                    </StepLabel>
                                </Step>
                            );
                        })}
                    </Stepper>
                </Paper>
                <Paper sx={{p:{xs:'2%',lg:'1% 0% 0% 0%'}}}>
                    <DataContext.Provider value={dataContextValue}>
                        {activeStep === steps.length ? (
                            <>
                                <BookingResponse/>
                            </>
                            ) : (
                                <>
                                    {renderStepContent()}
                                </>
                            )
                        }
                    </DataContext.Provider>
                </Paper>
            </StepperDataContext.Provider>
        </>
    </BookingDataContext.Provider>
  );
}

export default AddBooking;
export {BookingDataContext,StepperDataContext,DataContext}